<template>
	<div class="profil">
		<div>{{ utilisateurExterneInfo.denominationComplet }}</div>
	</div>
	<!--Civilité + Prénom nom-->
</template>

<script lang="ts">
	export default {
		props: {
			utilisateurExterneInfo: {
				type: Object,
				required: true
			}
		}
	};
</script>

<style lang="scss"></style>
